import {
  composeValidators,
  numberMaxValidator,
  numberMinValidator,
  numberValidator,
  regexValidator,
  textMaxLengthValidator,
  textValidator,
} from 'app/components/Form/utils/validators';

export const ASSET_MODEL_FORM_RULES = {
  categoryId: {
    validate: textValidator('PROCURE_3004'),
  },
  title: {
    validate: composeValidators(
      textValidator('PROCURE_3005'),
      textMaxLengthValidator('PROCURE_3005', 32),
    ),
  },
  mName: {
    validate: textValidator('PROCURE_3006'),
  },
  costOverride: {
    validate: composeValidators(
      numberValidator('PROCURE_3007'),
      regexValidator('PROCURE_3007', /^\d{1,3}(\.\d{1,2})?$/),
      numberMinValidator('PROCURE_3007', 0),
      numberMaxValidator('PROCURE_3007', 999.99),
    ),
  },
};
